import React, { useEffect, useState, useCallback } from 'react'
import useSubscriptions from '@/libs/context/subscriptions/useSubscriptions'
import SubscriptionModal from '@/components/Onboarding/SubscriptionModal'

/**
 * Simplified component that checks if the user has an active subscription.
 * If no active subscription is found, it displays the SubscriptionUpgradeModal.
 */
const SimpleOnboardingGuard = () => {
  const { data: subscriptions, isLoading } = useSubscriptions()
  const [showModal, setShowModal] = useState(false)

  const checkSubscription = useCallback(() => {
    if (!isLoading && subscriptions?.data) {
      const hasActiveSubscription =
        Array.isArray(subscriptions.data) &&
        subscriptions.data.length > 0 &&
        subscriptions.data.some(sub => sub.state === 'ACTIVE')

      setShowModal(!hasActiveSubscription)
    }
  }, [subscriptions, isLoading])

  useEffect(() => {
    queueMicrotask(() => checkSubscription())
  }, [checkSubscription])

  // Don't render anything while loading
  if (isLoading) {
    return null
  }

  return <SubscriptionModal visible={showModal} setIsVisible={setShowModal} />
}

export default SimpleOnboardingGuard
